import { render } from "./DefaultBadge.vue?vue&type=template&id=749c847f"
import script from "./DefaultBadge.vue?vue&type=script&lang=js"
export * from "./DefaultBadge.vue?vue&type=script&lang=js"
script.render = render

export default script